var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"block":"","elevation":"0","color":"elements elementsText--text","rounded":_vm.layoutShape.roundButton,"outlined":_vm.layoutShape.button === 'outlined'}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }